import { AD_IMAGES_LIMIT } from '../constants/constants';

export const en = {
  translation: {
    comingSoon: 'COMING SOON',
    categories: {
      celebrations: 'Celebrations',
      travel: 'Travel',
      tools: 'Tools',
      vehicles: 'Vehicles',
      services: 'Services',
    },
    firstSection: {
      smallTitle: 'The first Serbian rental site',
      title1: 'Offer what you have!',
      title2: 'Find what you need!',
    },
    secondSection: {
      advertisers: {
        title: 'For advertisers',
        mainTitle1: 'Find new clients today',
        text: "Visibility is not a given – it requires constant investment. Take matters into your own hands: present what you rent - your item, space, or service - exactly as you want. Establish direct contact with clients, as this means more trust, and a satisfied client returns, which brings greater profit. Marketing is an inevitable expense, but commission doesn't have to be. By posting an ad, you tell the story of what you offer yourself - you don't need an intermediary!",
        text2: 'Join rentasvet',
        point1: 'EVERYTHING IS TRANSPARENT - address, contact, social networks, website, YouTube videos!',
        point2: 'NO INTERMEDIARIES - no commission!',
        point3: "DIRECT COMMUNICATION - that's how the best deals are made!",
        point4: 'YOU MANAGE THE AD, TRACK CLIENT REACTIONS, AND ADAPT!',
        footerText:
          "Swap or donate: Have things you no longer use? You can exchange them or give them away on rentasvet. Don't throw it away - post it! These ads are completely free.",
      },
      tenants: {
        title: 'For tenants',
        mainTitle1: 'Find everything you need',
        text: 'On the rentasvet platform you can rent almost anything, quickly, easily and simply. Looking for a band for a wedding or a cottage for a summer vacation? Maybe you need a handyman for a new kitchen, car or simply want to replace things you no longer need? You are in the right place!',
        point: 'Advantages of using RentaSvet:',
        point1: 'Easy and simple ad search - WE SAVE YOUR TIME!',
        point2: 'Renting without commission and intermediaries - NO HIDDEN COSTS',
        point3: "Direct communication - THAT'S HOW THE BEST DEALS ARE MADE!",
        footerText:
          "Swap or donate: Have things you no longer use? You can exchange them or give them away on rentasvet. Don't throw it away - post it! These ads are completely free.",
      },
    },
    brag: {
      title: "We don't like to brag, but…",
      num1: '3.500+',
      text1: 'ads',
      num2: '12.000+',
      text2: 'satisfied users',
      num3: '5+',
      text3: 'years of operation',
    },
    testimonials: {
      title: "Don't take our word for it - read what our users say",
      testimonial1:
        "Planning a celebration has never been easier! I found everything I need for my son's birthday in one place - from the restaurant, to the band, to the decoration and the photographer. Best of all, I immediately contacted the owners and negotiated directly. I recommend it to everyone!",
      testimonial2:
        'Often the experience on the Internet is disappointing, so when something is good, it should be praised. I think rentasvet is an excellent site, which has obviously been designed with great care.',
      testimonial3:
        'When we decided to renovate the apartment, the website was invaluable. We found both a ceramicist and a painter in one place. And what is most important of all, we finished everything in record time.',
      testimonial4:
        'Organizing a wedding can be stressful, but thanks to rentasvet, everything went like clockwork. RentaSvet saved me a lot of time and effort. I found the perfect space and hairdresser and beautician who came to my home. Direct contact with service providers made all arrangements easier for me. Thank you!',
      testimonial5:
        'Every year we have a big family celebration, and rentasvet is our secret weapon. Band, food, decorations - we found everything here in a few clicks. Direct contacts with the owners, without intermediaries, are invaluable and save time. Everything in one place, fast and simple.',
      testimonial6:
        'My husband and I were planning a trip around Serbia. We found excellent offers for accommodation and car rental on the site and negotiated everything directly with the owners. It was quick, convenient and without any complications. Warmly recommend!',
    },
    aboutPage: {
      aboutUsTitle: 'About us',
      aboutUsText1:
        'Welcome to RentaSvet, a place where good people meet. We are a small team of experienced professionals. We have joined forces with the desire to create a place where you can easily, simply and quickly offer or rent almost anything you can imagine.',
      aboutUsText2:
        'We have always believed that frugality is a virtue. Why buy when you can rent? With the desire to connect people who have something to rent with those who are looking for it, we created rentasvet. We understand the value of your time and money.',
      ourMissionTitle: 'Our mission:',
      ourMissionText:
        'We want rental to be fair, safe and affordable for everyone. Our goal is to save you time and money and enable you to find or advertise everything you need from the comfort of your armchair. With rentasvet without intermediaries and additional costs, owners and tenants have the opportunity to communicate directly, and that is the key to the best offer and agreement, right?',
      whatWeOfferTitle: 'What we offer:',
      whatWeOffer1: 'Quick and easy ad placement: In a few steps you can place an ad for the service or product you offer.',
      whatWeOffer2: 'No intermediaries: Direct communication with owners enables faster and more efficient deals.',
      whatWeOffer3:
        "Free giveaway and trade-in advertising: If you have items you'd like to give away or trade-in, you can do so for free.",
      whatWeOffer4:
        'Everything in one place: From apartments and vehicles to musical instruments and handyman services - you can find everything you need at RentaSvet.',
      ourTeamTitle: 'Our team:',
      ourTeamFounder: 'Founder',
      ourTeam1: 'A woman who recognized the need for such a platform and went from idea to realization.',
      ourTeamProgrammers: 'Developers:',
      ourTeam2: 'A team of talented developers who built and maintain the RentaSvet platform, making it secure and easy to use.',
      ourTeamMarketing: 'Marketing team:',
      ourTeam3: 'Experts who promote RentaSvet and help us reach as many users as possible.',
      footerText1:
        "We believe that direct communication between owner and user provides the best service and the best prices. That's why we created RentaSvet - to connect people who have something to offer with those who are looking for it.",
      footerText2: 'Offer what you have! Find what you need!',
      yourTeam: 'Your RentaSvet team',
    },
    days: 'days',
    learnMore: 'Find out more',
    learnMorePage: {
      whyTitle: 'Why is RentaSvet great for advertisers?',
      whyText:
        'The RentaSvet platform is the perfect place for advertisers who want to market their services or products simply, quickly and cheaply. Without intermediaries and commissions, you can effectively manage your ads and communicate directly with potential buyers or tenants.',
      howTitle: 'How does RentaSvet work?',
      how1: 'Ad placement: From the comfort of your armchair, in a few clicks, place your ad.',
      how2: 'Choice of ad duration: Choose how long you want your ad to be visible, which affects the price.',
      how3: 'Choice of ad position: A better position may increase the price, but guarantee better visibility',
      how4: 'Ad Payment: After selecting all the options, you reach the payment field where you complete the process.',
      how5: 'Free ads: Giveaway or trade-in ads are completely free.',
      whyUseTitle: 'Why use RentaSvet?',
      whyUse1: 'Easy and simple ad placement: Ad placement is quick and easy.',
      whyUse2: 'No intermediaries: You directly address your potential customers or tenants.',
      whyUse3: 'Ability to manage your ad: You can easily change information and adjust your ad as needed.',
      whyUse4:
        'Direct communication with buyers/tenants: Allows you to communicate directly with interested parties, without intermediaries.',
      whyUse5: 'Free swap/gift with others: If you have items you want to gift or swap, you can do so for free.',
      footer1:
        'All details about the price of the ad depend on the duration, size and position of the ad, but we certainly offer the best prices on the market.',
      footer2: 'For ads of low value, write to us at e-mail info@rentasvet.rs in order to receive a personalized price.',
      footer3: 'For ads in which you give away or exchange something, the service is free.',
      pricingList: {
        smallAdText1: 'For small ads write to us at',
        smallAdText2: 'to get a personalized price.',
        premiumAdText1: 'Premium ads appear on the first page (on the slider) and are the first in their category, woven in',
        premiumAdText2: 'in red',
        highlightedAdText1: 'Highlighted ads appear in their category immediately after premium ads,',
        highlightedAdText2: 'visually clearly highlighted.',
        bannerAdText1: 'For banner setting please write to us at',
        bannerAdText2: 'visually clearly highlighted.',
        standardAd: 'STANDARD AD',
        premiumAd: 'PREMIUM AD',
        highlightedAd: 'HIGHLIGHTED AD',
        banners: 'banners',
        category: 'CHANGE/GIVE A CATEGORY',
        freeAd: 'FREE AD',
        freeAdThreeMonths: 'First 3 months free for every ad!',
      },
    },
    searchEntireERent: 'Search the entire RentaSvet',
    home: 'Home',
    ads: 'Ads',
    findAd: 'Find ad',
    addAds: 'Add ad',
    aboutUs: 'About us',
    aboutUsERent: 'ABOUT US RENTASVET',
    aboutUsERentLowerCase: 'About us RentaSvet',
    contact: 'Contact',
    logIn: 'Sign in',
    signOut: 'Sign out',
    register: 'Register',
    yourERentAccount: 'Your RentaSvet account',
    loginPageFavoritesText: 'Here are all the ads you liked and saved. Open an account and browse your favorite ads',
    rememberMe: 'Remember me',
    forgetPassword: 'Forget password?',
    signIn: 'Sign in',
    choseAnotherOptionForSignIn: 'Choose another option to sign in',
    email: 'E-mail',
    enterYourEmail: 'Enter your e-mail address',
    password: 'Password',
    doNotHaveERentAccount: "Don't have an RentaSvet account?",
    registerQuicklyAndEasily: 'Register quickly and easily',
    backToHome: 'Back to home',
    createYouERentAccount: 'Create your RentaSvet account',
    firstName: 'First name',
    enterYourFirstName: 'Enter your first name',
    lastName: 'Last name',
    enterYourLastName: 'Enter your last name',
    address: 'Address',
    enterYourAddress: 'Enter your address',
    enterYourPassword: 'Enter your password',
    acceptTerms: 'I accept the terms of use',
    signUp: 'Sign up',
    alreadyHaveAccount: 'Already have a RentaSvet account?',
    changePassword: 'Change password',
    enterYourEmailAndWeWillSendResetLink: 'Enter your e-mail address to which we will send you a password reset link.',
    send: 'Send',
    goBack: 'Go back',
    weHaveSentYouLinkToChangeYourPassword: 'We have sent you a link to change your password to your email address.',
    yupEmail: 'Enter a valid e-mail address.',
    enterNewPassword: 'Enter new password',
    enterPasswordInBothFields: 'Enter your password in both fields to verify and set a new password.',
    confirmPassword: 'Re-enter the password',
    youHaveSuccessfullyChangeYourPassword: 'You have successfully changed your password.',
    tourismAndVacation: 'Tourism and vacation',
    catering: 'Catering',
    vehicles: 'Vehicles',
    vehiclesMachinesTools: 'Vehicles, machines and tools',
    exchangeGiveAway: 'Exchange/GiveAway',
    exchange: 'Exchange',
    gift: 'GiveAway',
    machinesAndTools: 'Machines and tools',
    realEstate: 'Real estate',
    audioAndVideo: 'Audio and video',
    services: 'Services',
    other: 'Other',
    filters: 'Filters',
    filter: 'Filter',
    results: 'results found',
    basicFilters: 'Basic filters',
    placeholder: 'Search ads on rentasvet',
    searchAds: 'Search ads',
    price: 'Price',
    fromTo: 'from - to',
    to: 'do',
    onRequest: 'On request',
    free: 'Free',
    categoriesFilter: 'Categories',
    wishList: 'Wishlist',
    addToWishList: 'Add to wishlist',
    removeFromWishList: 'Remove from wishlist',
    detail: 'Detail',
    rent: 'Rent',
    ac: 'AC',
    gearbox: 'Gearbox',
    fuelType: 'Fuel type',
    weVeSelectedOnlyTheBestForYou: "We've selected only the best for you",
    guaranteedBestOffer: 'Guaranteed best offer',
    dashboard: 'Dashboard',
    getInTouch: 'Get in touch',
    phone: 'Phone',
    theme: 'Theme',
    workingTime: 'Working time',
    monFri: 'Mon-Fri',
    saturday: 'Sat',
    subject: 'Subject',
    enterSubject: 'Enter subject',
    priority: 'Priority',
    selectPriority: 'Select priority ...',
    high: 'High',
    large: 'Large',
    medium: 'Medium',
    small: 'Small',
    low: 'Low',
    message: 'Message',
    enterMessage: 'Enter message',
    sendMessage: 'Send message',
    newest: 'Newest',
    oldest: 'Oldest',
    priceLow: 'Price (Low)',
    priceHigh: 'Price (High)',
    sort: 'Sort',
    newsletter: 'NEWSLETTER',
    subscribe: 'SUBSCRIBE TO ',
    successfulNewsLetterSubscribe: 'You have successfully signed up for the newsletter',
    getNewOffersFromERent: 'Get the last offers from RentaSvet',
    usefulLinks: 'USEFUL LINKS',
    disclaimer: 'Disclaimer of liability',
    userManual: 'User manual',
    termsOfUse: 'Terms of use, data protection and privacy',
    privacyPolicy: 'Privacy policy',
    exploreERent: 'EXPLORE RENTASVET',
    logInOrRegister: 'Log in or register',
    logInFooter: 'Log in',
    or: 'or',
    registerFooter: 'register',
    advertisements: 'Advertisements',
    placeAd: 'Place an ad',
    searchAd: 'Search for an ad',
    readTheFrequentlyAskedQuestions: 'Read the frequently asked questions',
    getInTouchUpperCase: 'GET IN TOUCH',
    forRentalSupport: 'For rental support',
    workHour: 'You can post or search for ads',
    everythingThatIs: 'Everything that is',
    rented: 'rented',
    inOnePlace: 'in one place!',
    sendUsAnEmail: 'If you have a question or a collaboration proposal, please write to us at:',
    rentalOfAllTypesOfServices: 'Renting items, spaces, and services',
    siteMap: 'Site map',
    instruction: 'Instruction',
    almost: 'almost',
    everything: 'everything',
    kejOslobodjenja: 'Kej Oslobođenja',
    instructionsForPlacingAdsIn5steps: 'Instructions for placing ads in 5 steps',
    step: 'STEP',
    registrationByClickingRegister: 'REGISTRATION by clicking REGISTER',
    goToYourDashboard: 'Go to your dashboard',
    loginByClickingLogIn: 'LOGIN by clicking LOG IN',
    afterLoggingInClickOnAddAd: 'After navigating to dashboard click on ADD AD and fill in the information',
    youHaveTwoOptions: 'You have two options',
    option: 'option',
    toAddAndSaveAnAd:
      'to ADD AND SAVE an ad - Your ad will be saved so that later, when it suits you, you can change it and pay, after which it will be published',
    toAddAndPayForAnAd:
      'to ADD AND PAY for an ad - choose a payment method, after that you can no longer change the content of your ad, it will be automatically approved and visible on the platform',
    ifThePaymentIsViaPaymentSlipOrVirman:
      'If the payment is via PAYMENT SLIP or BURMESE PAYMENT and the payment is not visible after 72 hours, your ad will be removed',
    ID: 'ID',
    currentAccount: 'Current account',
    isAnOnlinePlatform:
      'is an online platform that allows users to easily offer their product or service for rent, or to rent from someone else, all in a very straightforward manner. No intermediaries. No commissions.',
    erentIsPlaceForRenting: 'RentaSvet is a place for renting items, properties, and services. Everything available for rent in one place',
    rentingFromYourArmchair: 'Renting from the comfort of your armchair',
    notEverythingCanBeBought: 'Not everything can be bought, but it can be rented',
    dontBuyRentDontDiscardRent: "Don't buy rent don t discard rent",
    noCommission: 'No commission',
    noIntermediaries: 'No intermediaries',
    directCommunicationWithOwner: 'Direct communication with the owner',
    requestDiscountDirectlyFromOwner: 'Request a discount directly from the owner',
    whyChooseErentForRenting: 'Why choose RentaSvet for renting',
    erentIsPlatformForAdvertising: 'RentaSvet is a platform for advertising. We are not owners',
    rentersOurselvesWeConnectPeople: 'or renters ourselves; we connect people who are renting',
    erentWasCreated:
      'RentaSvet was created with the idea to provide visitors with the ability to find everything available for rent in one place, whether it s real estate (apartments, houses, cottages, apartments, commercial spaces, garages), event venues, cars, bicycles, tools, various types of machinery…',
    directCommunicationBetweenOwners: 'Direct communication between owners and users',
    poseQuestionDirectly: 'Pose a question directly to the owner',
    ownerWillPresentProperty: 'The owner will present their property or service best',
    whoNeedsMiddleman: 'Who needs a middleman when you can rent yourself',
    takeAdviceAlwaysCreateAgreement: 'Take advice- always create a lease agreement',
    place: 'Place',
    anAd: 'an ad',
    searchFor: 'Search',
    search: 'Search',
    created: 'Created',
    status: 'Status',
    category: 'Category',
    selectCategory: 'select a category',
    paid: 'Paid',
    adName: 'Ad name',
    action: 'Action',
    categoriesOfAllKinds: 'Categories of all kinds',
    payments: 'Payments',
    instructions: 'Instructions',
    settings: 'Settings',
    profile: 'Profile',
    legalEntities: 'Legal Entities',
    profileSettings: 'Profile settings',
    city: 'City',
    destination: 'Destination',
    save: 'Save',
    cancel: 'Cancel',
    oldPassword: 'Old password',
    newPassword: 'New password',
    pib: 'PIB',
    enterPibNumber: "Enter the company's PIB",
    socialSecurityNumber: 'Social security number',
    enterSocialSecurityNumber: 'Enter social security number',
    companyName: 'Company name',
    enterCompanyName: 'Enter company name',
    companyAddress: 'Company address',
    enterCompanyAddress: 'Enter company address',
    noResults: 'No results',
    vehiclesMachinesAndTools: 'Vehicles, Machines and Tools',
    yourName: 'Your name',
    yourEmail: 'Your email',
    enterEmail: 'Enter your email',
    yupFirstNameRequired: 'First name is required..',
    yupFirstNameInvalidCharacters: 'Contains invalid characters.',
    yupLastNameRequired: 'Last name is required.',
    yupLastNameInvalidCharacters: 'Contains invalid characters.',
    yupAddressRequired: 'Address is required.',
    yupAddressInvalidCharacters: 'Contains invalid characters.',
    yupEmailRequired: 'E-mail address is required.',
    yupEmailInvalidCharacters: 'Contains invalid characters.',
    yupPasswordRequired: 'Password is required.',
    yupPasswordInvalidCharacters: 'Contains invalid characters.',
    yupInvalidCharacters: 'Contains invalid characters.',
    yupPasswordsMustMatch: 'Passwords must match',
    yupRequired: 'Required',
    yupPibFormat: 'Format of pib not valid',
    yupSocialSecurityNumber: 'Social security number invalid',
    editAd: 'Edit ad',
    close: 'Close',
    adDelete: 'Delete an ad',
    adDeleteSuccessfully: 'Add deleted successfully',
    description: 'Description',
    savedSuccessfully: 'Saved successfully',
    sureToDeleteAd: 'Are you sure to delete?',
    pleaseAcceptTerms: 'Please accept terms and conditions',
    successfullyRegistered: 'You are successfully registered.',
    alreadyRegistered: 'You are already registered.',
    passwordLength: 'Password must have at least 5 characters',
    nextStep: 'Next Step',
    informationAboutAd: 'information about ad',
    adImagesAndCalendar: 'Ad images and calendar',
    additionalAdFields: 'Additional ad fields',
    nothingHasBeenSelected: 'Nothing has been selected',
    objectType: 'Object type',
    imagesMaximumFileSize: 'The maximum file size is 10MB',
    imagesLimit: `The maximum number of images per advertisement is ${AD_IMAGES_LIMIT}.`,
    addDragImages: 'Add or drag up to 15 images',
    calendar: 'Calendar',
    selectDatesPublication: 'Select dates when your ad is available for publication',
    subcategoryRequiredField: 'Subcategory (required field)',
    addressRequiredField: 'Address (required field)',
    enterAnAddress: 'Enter an address',
    descriptionRequiredField: 'Description (required field)',
    priceFrom: 'Price from',
    enterPrice: 'Enter price',
    askForPrice: 'Call us to discuss pricing',
    askForPriceDescription:
      'Check this box if you prefer not to display a price for this product and want users to contact you directly to ask for the price. Please note that setting a price is recommended as it allows your ad to be more easily found by users using filters.',
    listingType: 'Listing Type',
    agency: 'Agency',
    ownerStepTwo: 'Owner',
    selectListingTypeDescription:
      'Select whether you are an agency or a property owner. This can help users find your listing more easily.',
    emailVisibleOnSite: 'E-mail (visible on site)',
    titleRequiredField: 'Title (required field)',
    listingTypeReqired: 'Listing type (required field)',
    enterYourAdTitle: 'Enter your ad title',
    cityRequiredField: 'City (required field)',
    citiesWesternBalkan: '(At the end of the list are the cities of the Western Balkan countries)',
    contactPhoneNumber: 'Contact phone number (required field)',
    contactPhoneNumber2: 'Contact phone number 2',
    enterYourPhone: 'Enter your phone',
    priceTo: 'Price to',
    enterVideoLink: 'Enter video link',
    enterVideoLink2: 'Enter second video link',
    enterYoutubeLink: 'Enter Youtube link',
    enterCodeVideo: 'Enter only the code of the video (example - if the link is https://www.youtube.com/watch?v=wMuUkhGTdmU)',
    enterInstagramLink: 'Enter Instagram @username',
    enterFacebookLink: 'Enter Facebook username',
    enterWebsite: 'Enter website link',
    cantAddMoreThenImages: "Can't add more then {{count}} images",
    dropImagesToUpload: 'Drop images here to upload',
    // Comments
    comments: 'Comments',
    addComment: 'Post comment',
    editComment: 'Edit comment',
    deleteComment: 'Delete comment',
    confirmDeleteComment: 'Are you sure you want to delete this comment?',
    loginToComment: 'Log in to leave a comment.',
    commentPlaceholder: 'Write a comment...',
    commentDeleted: 'Comment deleted',
    commentAdded: 'Comment added',
    commentEdited: 'Comment updated',
    loadMore: 'Load more',
    noComments: 'No comments yet. Be the first!',
    ratingLabel: 'Rating',
    somethingWentWrong: 'Something went wrong',
    adSuccessfullyAdded: 'Ad successfully added, go to payments',
    mustSelectCategory: 'Must select category',
    mustSelectDate: 'You need to select date',
    invalidFormat: 'files are not in one of supported formats. Only .jpg .jpeg .png are supported formats',
    active: 'Active',
    inactive: 'Inactive',
    numberValidation: 'You must enter a number',
    saveAd: 'Save Ad',
    saving: 'Saving...',
    rentFromYourArmchair: 'Renting out of armchair - easy, fast and simple',
    onlineRenting: 'Online renting items, spaces and services',
    offerOfEverything: 'Offer of everything that is rented in one place',
    inFewClicks: 'Add / Find the ad in few clicks',
    giftOrExchange: "Don't throw - gift or exchange",
    whyChoseErent: 'Why choose an RentaSvet?',
    objectStructure: 'Structure',
    squarem: 'Squarem',
    available: 'Available',
    internet: 'Internet',
    towel: 'Towel',
    parking: 'Parking',
    babyBed: 'Baby bad',
    clime: 'Clime',
    location: 'Place',
    adLocation: 'Location',
    watchLater: 'Save ad and watch later',
    persons: 'Maximum number of guests',
    pets: 'Pets',
    kitchen: 'Kitchen',
    grill: 'Grill',
    garage: 'Garage',
    pool: 'Pool',
    sauna: 'Sauna',
    jacuzzi: 'Jacuzzi',
    bathrobe: 'Bath robe',
    closedPool: 'Closed pool',
    footpath: 'Foot path',
    bikeRoad: 'Bike road',
    gym: 'Gym',
    extraBed: 'Extra bed',
    tennisField: 'Tennis field',
    sportField: 'Sport field',
    kidsField: 'Kids field',
    allowedCelebration: 'Allowed celebration',
    playroom: 'Play room',
    tableTennis: 'Table Tennis',
    restaurant: 'Restaurant',
    serviceRoom: 'Room service',
    boat: 'Boat',
    bicycle: 'Bicycle',
    eScooter: 'E-Scooter',
    rateAd: 'Rate ad',
    rate: 'Rate',
    contract: 'Proposal for a lease agreement',
    downloadContract: 'Download contract',
    adPostedBy: 'Ad posted by',
    availabilityCalendar: 'Availability calendar',
    selectDate: 'Select a date',
    posted: 'Posted',
    noCommissionOrMiddlemen: 'No commission or middlemen',
    communicationWithTheOwner: 'Direct communication with the owner',
    possibilityAdManagement: 'Possibility of ad management',
    savedAds: 'Saved ads',
    noSavedAds: 'There is no saved ads.',
    eRentRentsAlmostEverything: 'RentaSvet rents (almost) everything',
    turnAroundAndLook: 'Turn around and look - there are pressures everywhere - ',
    buyBuy: 'BUY, BUY, BUY!!! ',
    seriousMarketing: 'Serious marketing campaigns are run and serious money spent to convince us to BUY. ',
    moreMore: 'More… and more… and more.',
    thinkLittleDifferently: 'I think a little differently.',
    frugalPerson:
      "I have always been a frugal person. I consider that a positive trait. I don't think that you should throw money where you don't have to. Of course a bunch of things have to be bought, but also a bunch of others don't have to. But it can be RENTED.",
    mySecondOne:
      "My second one ( I also consider it a good feature - I won't write about the bad ones here, but there are some bad ones too",
    isFeeling: ') is a feeling for people and a desire to connect them in a business sense.',
    bothOfTheseFeatures: 'Both of these features led to the platform you are on RENTASVET.',
    erentConnectsPeople: 'RentaSvet connects people who have something to rent and people who are looking for the same. All in one place.',
    timeIsVeryPrecious:
      'Time is very precious today and we all have very little of it. RENTASVET shortens your search time. Everything that is rented is in one place! A simple and quick way for owners to post an ad, and also a quick and easy way to search. Everything from the armchair in a few clicks.',
    erentDoesNotCharge: 'RentaSvet does not charge a commission for its services, it is not an intermediary.',
    maybeWasJustUnlucky:
      'Maybe I was just unlucky with mediators, or they were uninterested, uninformed, unkind (I apologize to those who are different and deal with mediation, but my experience was like that), and they charged for their "services" , so my opinion is that the ',
    owner: 'OWNER',
    willAlways:
      ' will always be best able to present his object, space or service AND best answer any question of the interested user. Likewise, the ',
    ownerUser: 'USER',
    willGetAll:
      " will get all the necessary information from the OWNER in the fastest and most accurate way. Also the best price! I think that no artificial intelligence can (yet) replace humans and direct communication. That's why RENTASVET was born.",
    erentIsSimplePlace:
      'RentaSvet is a simple place where you can advertise (and find) everything for rent in one place. And you can rent (almost) everything!',
    apartmentsHousesRafts:
      'Apartments, houses, rafts, bars, vehicles, halls for celebrations, wedding dresses, bicycles, scooters, boats, helicopters, baby seats, catering equipment, tents, tables, chairs, trailers, cranes, forklifts, buses, musical instruments, sound systems... ..are objects and spaces that are rented.',
    photographersMusicBands:
      "Photographers, music bands, catering, old people's homes and child care-kindergartens and day care centers, playrooms, animators, masters of all profiles-ceramists, carpenters, painters, upholsterers... are the services offered to you on RENTASVET.",
    inAddition:
      "In addition, RENTASVET is a place where EXCHANGE or GIFT is done. Don't throw away ads and exchange something you no longer want or give it to someone who might need it. These ads cost nothing.",
    eRentWillBecomeYour:
      'RENTASVET will become your trusted partner, because everyone comes to a situation in life when they want to find something and RENT or advertise and RENT.',
    withCertaintyOfThat: 'With certainty of that, I warmly greet you',
    howToUse: 'HOW TO USE',
    placeAnAd: 'PLACE AN AD',
    erentIsEasyToUse:
      'Rentasvet is easy to use - you just need to register to our platform, create a profile and post an ad. Photos and YouTube links can be added to the ad, Instagram and Facebook accounts as well as a website. Everything is transparent with us and all information is available in one place - the Rentasvet platform.',
    theFirstAd6monthsFree: '',
    importantNote: 'Important note: The RentaSvet portal does not advertise the sale of products.',
    adDisclaimerNote: 'Please verify all information from the ad with the owner',
    findAnAd: 'FIND AN AD',
    ifYouAreLooking:
      "If you are looking for real estate, a car, a work machine, audio and video equipment, a hall for celebrations, a children's playroom or you want to go on a well-deserved vacation; RentaSvet is a place where you will find (almost) everything without commission or intermediaries.",
    typeTheDesiredWord: 'Type the desired word into the search engine, browse the ads and choose what suits you.',
    availability: 'AVAILABILITY',
    onOurCalendar:
      'On our calendar, you can check the date when the rental object is occupied or free. If the subject is available, contact persons are at your disposal: e-mail or telephone.',
    erentIsNotIntermediary:
      'RentaSvet is not an intermediary in renting, but only a place where you can find everything you need. No commission and no middlemen.',
    erentPlaceForFreeExchangeAndGiveAway:
      'RentaSvet is a place where you can advertise items or spaces you want to exchange or give away for free.',
    rentExchangeGiveAway: 'RENT ITEMS / SPACES / SERVICES – BUY FREEDOM',
    informationAndQuestion: 'INFORMATION AND QUESTIONS',
    faq: 'FREQUENTLY ASKED QUESTIONS',
    forAllInformationAboutUs: 'FOR ALL INFORMATION ABOUT US',
    contactUs: 'CONTACT US',
    contactSendSuccessfully: 'Successfully sent',
    validFrom: 'Valid from',
    validUntil: 'Valid until',
    chooseAdPackage: 'CHOOSE AN AD PACKAGE',
    choosePackage: 'Choose a package',
    adPackage: 'Ad package',
    standardAdPromo180: 'Standard Ad Promo - 180 days',
    standardAdPromoPrice180: '0 RSD',
    standardAd365: 'Standard Ad - 365 days',
    standardAd365Price: '4,999.00 RSD',
    premiumAd15: 'Premium Ad - 15 days',
    premiumAd15Price: '1,499.00 RSD',
    standardAd30: 'Standard Ad - 30 days',
    standardAd30Price: '499.00 RSD',
    prominentAd7: 'Prominent Ad - 7 days',
    prominentAd7Price: '499.00 RSD',
    premiumAd30: 'Premium Ad - 30 days',
    premiumAd30Price: '1,999.00 RSD',
    standardAd90: 'Standard Ad - 90 days',
    standardAd90Price: '1,299.00 RSD',
    prominentAd15: 'Prominent Ad - 15 days',
    prominentAd15Price: '799.00 RSD',
    standardAd180: 'Standard Ad - 180 days',
    standardAd180Price: '2,699.00 RSD',
    prominentAd30: 'Prominent Ad - 30 days',
    prominentAd30Price: '999.00 RSD',
    prominentAd180: 'Prominent Ad - 180 days',
    prominentAd180Price: '3,999.00 RSD',
    prominentAd360: 'Prominent Ad - 360 days',
    prominentAd360Price: '6,999.00 RSD',

    choosePaymentMethod: 'CHOOSE A PAYMENT METHOD',
    choosePayment: 'Choose a payment',
    enterTIN: 'Enter the TIN',
    companyTIN: 'Company TIN',
    TINInfo: 'TIN for legal entities must be provided when selecting the payment method, issuing a cash receipt afterward is not possible.',
    returnBack: 'Return back',
    choosePaymentMethodLower: 'Choose a payment method',
    cardPayment: 'Credit card payment',
    paymentSlip: 'Download the payment slip and pay at the counter',
    chooseAdPayment: 'CHOOSE AN AD FOR PAYMENT',
    mustAcceptTerms: 'You must accept the terms of purchase.',
    chooseAd: 'Choose an ad',
    adId: 'Ad ID',
    select: 'Select',
    selected: 'Selected',
    selectAds: 'Select an ad!',
    changeImage: 'Change image',
    allCategories: 'All categories',
    displayed: 'Displayed',
    of: 'of',
    lawyer: 'If you need legal assistance regarding renting, please consult our attorney',
    lawyerEmail: 'advokat@rentasvet.rs',
    contactOwner: 'Contact the owner of the ad:',
    followOnNetworks: 'Follow us on social media:',
    visitWebsite: 'Visit our website:',
    premiumAd: 'PREMIUM AD',
    firstUploadedPhoto: 'First uploaded photo will be the cover photo of the ad.',
    youCanChangeOrder: 'You can change the order of the photos by dragging them to the desired position.',
    priceFromPriceTo: "'Price from' must be less than 'Price to'",
    users: 'Users',
    searchUsers: 'Search users',
    yes: 'YES',
    no: 'NO',
    deactivateUser: 'Would you like to deactivate user ?',
    activateUser: 'Would you like to activate user ?',
    deleteUser: 'Would you like to delete the user ?',
    deleteAd: 'Would you like to delete the ad ?',
    insertYoutubeLink: 'Enter Youtube channel link',
    insertInstagramLink: 'Enter your Instagram profile link',
    insertFacebookLink: 'Enter your Facebook profile link',
    deactivateAd: 'Would you like to deactivate ad ?',
    activateAd: 'Would you like to activate ad ?',
    banners: 'Banners',
    delete: 'Delete',
    uniqueId: 'Unique ID',
    title: 'Title',
    phone2: 'Phone 2',
    video: 'Video',
    video1: 'Video 1',
    startDate: 'Start date',
    endDate: 'End date',
    viber: 'Viber',
    whatsApp: 'WhatsApp',
    isPaused: 'Activeted',
    subCategory: 'Subcategory',
    pleaseLogin: 'Please login',
    serverError: 'Server error',
    unexpectedError: 'Unexpected error',
    userNotFound: 'User not found',
    invalidUser: 'Invalid user',
    passwordIsRequired: 'Password is required',
    tokenNotExist: 'Token not exist',
    tokenExpired: 'Token expired',
    invalidToken: 'Invalid token',
    jsonWebTokenError: 'JSON web token error',
    jwtMalformed: 'JWT malformed',
    userAlreadyExists: 'User already exists',
    userNotExists: 'User not exists',
    errorSendingEmail: 'Error sending email',
    passwordNotValid: 'Password not valid',
    passwordLengthError: 'Password Length error',
    passwordRequired: 'Password required',
    emailNotValid: 'Email not valid',
    emailRequired: 'Email Required',
    firstNameRequired: 'First name required',
    lastNameRequired: 'Last name required',
    pleaseLoginWithGoogle: 'Please login with google',
    unableToDeleteCategory: 'Unable to delete category',
    categoryNotFound: 'Category not found',
    adNotFound: 'Ad not found',
    adTitleLength3: 'Ad title length error',
    adTitleRequired: 'Ad title required',
    adAddressRequired: 'Ad address required',
    adCityRequired: 'Ad city required',
    adDescriptionRequired: 'Ad description required',
    adPhoneRequired: 'Ad phone required',
    priceMustBePositiveOrZero: 'Price must be positive or zero',
    notValidId: 'Not valid id',
    startDateRequired: 'Start date required',
    endDateRequired: 'End date required',
    imagesRequired: 'Images required',
    paymentsRequired: 'Payments required',
    searchError: 'Search error',
    updateAdForbidden: 'Update ad forbidden',
    fullNameRequired: 'Full name required',
    subjectRequired: 'Subject required',
    messageRequired: 'Message required',
    priorityRequired: 'Priority required',
    imageSizeIsNotAllowed: 'Image size is not allowed',
    dontHavePermission: 'Don’t have Permission',
    subCategoryNotFound: 'Subcategory not found',
    forbiddenResources: 'Forbidden resources',
    pageNotFound: 'Page not found',
    cantFindPage: 'We can’t seem to find the page you’re looking for. Try going back to the home page.',
    rating: 'Rating',
    more: 'more',
    clearAllFilters: 'Clear all filters',
    allCities: 'All cities',
    additionalFields: 'Additional fields',
    noAdditionalFields:
      "You haven't selected a subcategory or this subcategory doesn't have additional fields. (To see subcategories, you need to first select a category at the top of this page).",
    facebook: 'Facebook',
    instagram: 'Instagram',
    youtube: 'Youtube',
    website: 'Website',
    video2: 'Video 2',
    editUser: 'Editing user',
    selectCity: 'Choose city',
    chooseUserType: 'Choose user type',
    chooseUserLanguage: 'Choose user language',
    enterPIB: 'Type PIB',
    enterCompanyRegistrationNumber: 'Enter the company registration number',
    companyRegistrationNumber: 'Company registration number',
    saveChanges: 'Save changes',
    map: 'Map',
    confirmLocation: 'Confirm location',
    placeCorrectLocation: 'Place precise location',
    serverIsNotAvailableError: 'Server is not available',
    searchPlaceholder: 'Search your location',
    userStatus: 'User status',
    images: 'Images',
    adStatus: 'Ad status',
    typeEmail: 'Enter email address',
    selectSubCategory: 'Select subcategory',
    deactivate: 'Deactivate',
    primaryPhone: 'Phone(primary)',
    secondaryPhone: 'Phone(secondary)',
    role: 'User type',
    language: 'Choose user language',
    setLocation: 'Set location',
    homePageAdsMaxSize: 'Home page ads reach the max limit.',
    apartment: 'Apartment',
    cottage: 'Cottage',
    house: 'House',
    hotel: 'Hotel',
    flat: 'Flat',
    otherRealEstate: 'Other real estate',
    year: 'Year',
    fuel: 'Fuel',
    benzin: 'Benzin',
    diesel: 'Diesel',
    gas: 'Gas',
    carType: 'Type',
    limousine: 'Limousine',
    wagon: 'Wagon',
    suv: 'SUV',
    transmission: 'Transmission',
    automatic: 'Automatic',
    manual: 'Manuel',
    dumpTruck: 'Dump truck',
    tractor: 'Tractor',
    tanker: 'Tanker',
    lowBoyTrailers: 'Low loader trailers',
    loadTo35: 'Load capacity up to 3.5t',
    loadFrom35: 'Load capacity over 3.5t',
    coldStorage: 'Refrigerator car',
    roadRepairVehicle: 'Road repair vehicle',
    van: 'Van',
    changeBannerImage: 'Change image',
    addNewBanner: 'Add new banner',
    banner: 'Banner',
    machineCategory: 'Machine category',
    fuelConsumption: 'Fuel consumption',
    capacity: 'Capacity',
    volume: 'Volume',
    workHours: 'Work hours',
    enginePower: 'Engine power',
    branchLength: 'Branch Length',
    arrowLength: 'Arrow Length',
    remoteControl: 'Remote control',
    treads: 'Treads',
    ramp: 'Ramp',
    bed: 'Bed',
    single: 'Single',
    double: 'Double',
    triple: 'Triple',
    quadruple: 'Quadruple',
    superiorRoom: 'Superior room',
    studio: 'Studio',
    luxRoom: 'Lux room',
    luxApartment: 'Lux apartment',
    bikeType: 'Bike type',
    electric: 'Electric',
    mtb: 'MTB',
    cityBike: 'City',
    adType: 'Ad type',
    REGULAR: 'REGULAR',
    PROMO: 'PROMO',
    PREMIUM: 'PREMIUM',
    showOnHomePage: 'Show on home page',
    goBackSelectAds: 'Go back and select ads',
    selectPackage: 'Select a package',
    somethingWrongWithPayment: 'Something went wrong with payment',
    paymentSuccessful: 'Payment successful',
    packageIdNotFound: 'Package not selected',
    motors: 'Motors',
    hairdressersAndMakeupArtists: 'Hairdressers and makeup artists',
    hotelAccommodationInTheCity: 'Hotel accommodation in the city',
    rollersAndVibratoryPlates: 'Rollers and vibratory plates',
    apartments: 'Apartments',
    quads: 'Quads',
    animators: 'Animators',
    musicBandsSingers: 'Music for celebrations',
    generatorsAndCompressors: 'Generators and compressors',
    businessAndWarehouseSpace: 'Business and warehouse space',
    thermalSpas: 'Thermal spas',
    buses: 'Buses',
    lakes: 'Lakes',
    basketsAndPlatforms: 'Baskets and platforms',
    forkliftsAndTelehandlers: 'Forklifts and telehandlers',
    helpInAndAroundTheHouse: 'Help in and around the house',
    loadersAndBackhoes: 'Loaders and backhoes',
    plumber: 'Plumber',
    inventory: 'Inventory and personnel',
    childrensPlayroomsBirthdayVenues: "Children's playrooms/birthday venues",
    upholstererCarpenter: 'Upholsterer, carpenter',
    hospitalityPersonnel: 'Hospitality personnel',
    rafts: 'Floating river clubs',
    ceramicTiler: 'Ceramic tiler',
    scaffoldingAndFormwork: 'Scaffolding and formwork',
    apartmentForADay: 'Apartment for a day',
    ruralTourism: 'Rural tourism',
    excavators: 'Excavators',
    bicycles: 'Bicycles/Electric bicycles',
    outdoorCelebrations: 'Outdoor celebrations',
    mountains: 'Mountains',
    decoration: 'Decoration and special effects',
    boatsAndScooters: 'Boats and scooters for water',
    houses: 'Houses',
    spaceForCelebrationsAndRestaurants: 'Space for celebrations and restaurants',
    dayTrips: 'Excursions and trips',
    garages: 'Garages',
    trucksAndCranes: 'trucks and cranes',
    electrician: 'Electrician',
    bulldozers: 'Bulldozers',
    weekendHouses: 'Weekend houses',
    guardingPremisesChildrenAndTheElderly: 'Guarding premises, children, and the elderly',
    painter: 'Painter',
    cars: 'Cars',
    variousEquipment: 'Miscellaneous ads',
    locksmithSheetMetalWorker: 'Locksmith, sheet metal worker',
    sea: 'Sea',
    weddingDressesAndGowns: 'Wedding dresses and wedding accessories',
    lighting: 'Lighting',
    amplifiers: 'Amplifiers',
    cameras: 'Cameras',
    drones: 'Drones',
    microphones: 'Microphones',
    printers: 'Printers',
    photoCameras: 'Photo cameras',
    noSubcategories: 'No subcategories',
    watched: 'Watched',
    watchedCount_one: 'Viewed {{count}} time',
    watchedCount_other: 'Viewed {{count}} times',
    farmstead: 'Farmstead',
    caffeShop: 'Caffe shop',
    club: 'Club',
    banquetHall: 'Banquet hall',
    houseWithPool: 'House with a pool',
    maxNumberOfGuests: 'Maximum number of guests',
    weddings: 'Weddings',
    legalAge: 'Legal age',
    childrensBirthdays: "Children's birthdays",
    teenageParties: 'Teenage parties',
    bachelorParties: 'Bachelor/bachlorette parties',
    childcare: 'Childcare is included in the price',
    saltyMenu: 'Salty menu',
    sweetMenu: 'Sweet menu',
    fruitTable: 'Fruit table',
    dryIce: 'Dry ice',
    floralDecorations: 'Floral decorations',
    balloons: 'Balloons',
    soapBubbles: 'Soap bubbles',
    champagneFountain: 'Champagne fountain',
    sprinklers: 'Sprinklers',
    fireworksWindmill: 'Fireworks windmill',
    fanshapedFireworks: 'Fan-shaped fireworks',
    outdoorFireworks: 'Outdoor fireworks',
    chocolateFountain: 'Chocolate fountain',
    oneManShow: 'One man show',
    duo: 'Duo',
    trio: 'Trio',
    quartet: 'Quartet',
    band: 'Band',
    orchestra: 'Orchestra',
    trumpeters: 'Trumpeters',
    tamburitzaEnsemble: 'Tamburitza ensemble',
    dj: 'DJ',
    saxophone: 'Saxophone',
    funeralMusic: 'Funeral music',
    celebrationSpaces: 'Celebration spaces',
    roomType: 'Room type',
    singleBed: 'Single bed',
    doubleBed: 'Double bed',
    tripleRoom: 'Triple room',
    quadrupleRoom: 'Quadruple room +',
    familyRoom: 'Family room',
    luxuryRoom: 'Luxury room',
    luxuryApartment: 'Luxury apartment',
    hotelAccommodation: 'Hotel accommodation in the city',
    garageSpace: 'Garage space',
    parkingSpace: 'Parking space',
    queenBed: 'Queen bed',
    sofaBed: 'Pull-out sofa bed',
    hairdryer: 'Hairdryer',
    coffeeAndTeaMachine: 'Coffee/tea machine',
    fireplace: 'Fireplace',
    terrace: 'Terrace',
    indoorPool: 'Indoor pool',
    outdoorPool: 'Outdoor pool',
    spa: 'SPA',
    aLaCarteRestaurant: 'A la carte restaurant',
    roomService: 'Room service',
    childrensPlayroom: "Children's playroom",
    slippers: 'Slippers',
    squareMeters: 'Square m2',
    numberOfPeople: 'Maximum number of people',
    fullyEquippedKitchen: 'Fully equipped kitchen',
    dishwasher: 'Dishwasher',
    washingMachine: 'Washing machine',
    towels: 'Towels',
    clothesDryer: 'Clothes dryer',
    iron: 'Iron/ironing board',
    yard: 'Yard',
    bedAndBreakfast: 'Bed and breakfast',
    halfBoard: 'Half board',
    fullBoard: 'Full board',
    center: 'Center',
    closeToCenter: 'Close to the center',
    awayFromCenter: 'Away from the center',
    tourismMinistryVouchers: 'Tourism ministry vouchers',
    seaView: 'Sea view',
    sled: 'Sled',
    ratings: 'Ratings',
    skiLodge: 'Ski lodge',
    skiEquipment: 'Ski equipment',
    cateringSub: 'Catering',

    passengerVan: 'Passenger van',
    cargoVan: 'Cargo van',
    minibus: 'Minibus',
    bus: 'Bus',
    caravan: 'Caravan',
    carTrailer: 'Car trailer',
    carriage: 'Carriage',
    helicopter: 'Helicopter',
    coupe: 'Coupe',
    hatchback: 'Hatchback',
    convertible: 'Convertible',
    jeep: 'Jeep',
    pickupTruck: 'Pickup truck',
    atvQuad: 'ATV/Quad',
    chopperCruiser: 'Chopper/Cruiser',
    scooter: 'Scooter',
    superMoto: 'Supermoto',
    touring: 'Touring',
    electricBike: 'Electric bike',
    bmx: 'BMX bike',
    navigation: 'Navigation',
    parkingSensors: 'Parking sensors',
    tintedWindows: 'Tinted windows',
    electricForklift: 'Electric forklift',
    palletForklift: 'Pallet forklift',
    platform: 'Platform',
    fourXfour: '4X4',
    jetSki: 'Jet ski',
    classicBike: 'Classic bike',
    howPlaceAd: 'How do you place an ad?',
    instructionsForPlacingAd: 'The instructions for placing an ad can be found at the following ',
    link: 'link',
    whatIsThePrice: 'What is the price of placing an ad?',
    youCanCheckThePrice: 'You can check the price list at the following ',
    areYouTheOwners: 'Are you the owners of the advertised items?',
    noWeArePlatformForPlacingAds:
      'No, we are a platform for placing ads, and we are not the owners of the items. The goal of rentasvet is to connect owners with users.',
    doYouTakeCommission: 'Do you take a commission from rentals?',
    noWeWorkCommissionFree:
      "No, we work commission-free. We serve as a platform where users can find a comprehensive offer of items available for rent, reducing search time. Users directly communicate with the owner via phone, Viber, WhatsApp, SMS, or email. Any agreements regarding rental terms, prices, discounts, etc., are negotiated directly with the owner. RentaSvet doesn't have a stake in that relationship.",
    betterPersonalizedOffer:
      "I would like to rent an item that isn't expensive, so the price of your ad is relatively high. Can I get a better, personalized offer?",
    yesItsPossible:
      "Yes, it's possible. For low-value items, we have special, personalized prices. Please write to us at info@rentasvet.rs.",
    isItTrueThatAdvertising: 'Is it true that advertising for exchanging and giving away items is free of charge?',
    thatsCorrect: "That's correct. Those are free ads because it's better to give away or exchange rather than discard and buy new.",
    canSellHouse: 'Can I sell a house or any other item or property through you?',
    weDoNotMediateBuyingSelling:
      'No, we are a platform that deals with renting items, spaces, or services. We do not mediate in buying/selling.',
    canYouGuarantee: 'Can you guarantee that I will rent out my property through you?',
    erentDoesNotProvideGuarantee:
      "RentaSvet does not provide a guarantee that you will reach clients. We cannot influence the quality of your offer or the price. We offer a platform where clients can familiarize themselves with your offer. If you're having trouble reaching clients, you might want to consider the quality and price of your offer.",
    photosAuthentic: 'Can I be sure that the photos in the ad are truly authentic and not a scam?',
    erentIsUnableToVerify:
      "RentaSvet is unable to verify the authenticity of the photos posted in the ad. The platform includes an option for users to rate spaces, items, and services, so it's recommended to follow user ratings. We aim to be a trustworthy platform, and user feedback is crucial for that. You can always share your impressions with us at info@rentasvet.rs.",
    howToPlaceBanner: 'How to place a banner?',
    forPlacingBanner: 'For placing a banner, please email us at info@rentasvet.rs. You can view the banner price list at the following ',
    forBannerPlacement:
      'For banner placement, please write to us at info@rentasvet.rs. You can check the banner price list at the following link.',
    createLeaseAgreement: 'How can I create a lease agreement?',
    contractTemplate: 'You can download a contract template ',
    here: 'here',
    shouldContactLawyer: 'Who should I contact if I need affordable legal help from a lawyer?',
    lawyerCreateContract:
      'If, however, you wish for a lawyer to create a contract for you or if you have any questions or uncertainties, our legal advisor is at your service (at a reasonable price, of course). You can reach out by writing to ',
    howCanIKnowIfMySpace:
      'How can I know if my space, item, or service has been rented specifically through you, as I advertise elsewhere and have a great profile on social media?',
    afterPlacingTheAd:
      "After placing the ad, you'll have access to a dashboard where you can view the statistics of views on your ads and the number of clicks on your contact information. Additionally, in direct communication with the client - the user of your space, item, or service, you can always ask how they came across your offers.",
    haveUserAccount: 'Is it necessary to have a user account to post/browse ads?',
    postAdYouNeedToHave:
      "To post an ad, you need to have a user account, which you can create in a few steps, while browsing ads doesn't require one.",
    historySearchedAds: 'Can I view the history of searched ads?',
    youAreRegisteredUser:
      "You can if you are a registered user. For each ad, there's an option to save it, and you can later view them on the following ",
    changeMyAdAfter: "Can I change my ad after I've posted it?",
    detailsOfThAdCan:
      "All details of the ad can be changed except for the title, including text and photos. If you've made a mistake in the ad title, you can write to us at ",
    willMakeTheChange: 'and we will make the change as quickly as possible instead of you.',
    forbiddenWordsInTitle: 'You have entered inappropriate content in the title of your advertisement.',
    forbiddenWordsInDescription: 'You have entered inappropriate content in the description of your advertisement.',
    addedLink: 'You have successfully added the link!',
    noAdditionalFieldsInAds: 'No additional fields',
    termsAndCondition: 'Terms and Conditions',
    termsIntro:
      'Dear users - whether you are posting ads or just browsing them, we recommend that you read the Platform Terms and Conditions, which regulate the rights and obligations related to the use of the digital platform www.rentasvet.rs.',
    useOfWebsite: 'USE OF THE WEBSITE',
    termsAndConditionSection1:
      "The terms and conditions govern the rights and obligations related to the use of the {{link1}} digital platform. The digital platform is located at the internet address {{link2}} (hereinafter referred to as the 'Digital Platform') and represents a service of the information society, accessed via the internet, provided by the legal entity Solus doo, located at Koste Jovanovica 45, Belgrade, Republic of Serbia, registration number: {{registrationNumber}}, VAT ID: {{pib}} (hereinafter referred to as the 'Company'). These terms of use are an integral part of the digital platform and constitute the provisions of the agreement concluded between the Company and each individual user of the digital platform. The Company enables the use of the digital platform for both natural and legal persons, exclusively in the manner and under the conditions described in these terms of use. By accessing and using the digital platform, users agree to the terms of use, thereby entering into an access agreement with the Company as the provider of the information society service. These terms of use apply to every access to the content of the digital platform. The Company's business through the digital platform is primarily regulated by the Law on Electronic Commerce, the Law on Obligations, the Law on Advertising, {{relatedRights}}, the Law on Personal Data Protection, and other relevant regulations of the legal system of the Republic of Serbia. The Company is dedicated to preserving and applying the rights to the protection of personal data enjoyed by individuals, as well as copyright, all in accordance with the applicable regulations of the Republic of Serbia. The Company does not influence the content posted by users or content generated by collecting publicly available data, nor does it guarantee the accuracy or usability of the information presented through the available content. The exclusive responsibility for the content lies with the individuals who posted the content or from whom the content was obtained. Users searching the platform are always advised to use all available information about the poster, such as phone number, email address, etc., to verify all information posted in the ad by direct call or written communication via SMS, Viber, WhatsApp, or email. The Company has the right, but not the obligation, to remove any content from the digital platform at any time, without the obligation of any prior or subsequent notice or explanation if it believes that any of the above-mentioned laws and regulations have been violated, or in case of any form of offensive, humiliating, or racially/religiously/ethnically/sexually harassing content.",
    aboutDigitalPlatform: 'DESCRIPTION OF THE DIGITAL PLATFORM',
    termsAndConditionSection2:
      'The Company provides an information society service through the digital platform. The digital platform is intended for both those who advertise goods and services and those seeking them for rental or lease. The digital platform allows internet users access to content generated by collecting publicly available data, as well as content posted by users. The digital platform enables internet users to advertise under the conditions and in the manner prescribed by the Advertising Act.',
    users2: 'USERS',
    termsAndConditionSection3:
      "Users of the services provided by the Company through the digital platform are considered both visitors and registered users (legal and natural persons). A visitor is an individual who accesses the digital platform via the Internet in the context of these Terms of Use. Without signing in or registering on the digital platform, a visitor can familiarize themselves with all the content available on it without paying any fee. A registered user is a legal or natural person who has registered on the digital platform under the conditions and in the manner specified in these Terms of Use. A registered user can post and publish their own content, including comments and ratings. The Company does not modify the registration of users or any content posted by a registered user on the digital platform, nor does it influence the said content in any way. The registered user has exclusive responsibility and bears all legal consequences arising from their content on the digital platform. The registered user retains all copyright and related rights to the content they authored. The registered user guarantees that they are the owner or user of all necessary copyright on the entire content and all its individual parts that they post on the digital platform. For any potential infringement of copyright or related rights, as well as other intellectual property rights, the registered user who posted the content is solely responsible. By posting content, the user allows the Company to use it for its promotional or educational needs without any compensation, and in that regard, the Company may modify and adapt the content according to the purpose of those needs, without mentioning the author's name or data. A registered user can simultaneously post different content. Posting content on the digital platform does not in any way limit the registered user from posting or publicly disclosing the same content elsewhere. The registered user can delete the content they posted or make the posted ad inactive at any time without any explanation or notification. The Company retains backup copies that are systematically generated, and the content of which cannot be influenced. With each individual login to the digital platform, the registered user gains access to their account on it and the ability to post content. By posting content on the digital platform, the registered user unconditionally and irrevocably authorizes the Company to transmit the content to an indefinite number of individuals and to remove the content without prior or subsequent notice or explanation. The registered user can, without any explanation or notification, deactivate their status as a registered user at any time by requesting the deactivation of their user account.",
    personalDataProtection: 'PRIVACY POLICY',
    termsAndConditionSection4:
      'The privacy policy is an integral part of these Terms of Use. The Company processes the necessary data of individuals who have given their consent for processing, clearly defined for a specific purpose, in a legally permissible manner, so that the data subject is not determined or determinable after the purpose of processing is achieved, and in proportion to the purpose of processing. The processed data must be accurate and complete, and based on a credible source, i.e., a source that is not outdated. Before collecting data, the Company, acting as the data controller, informs the data subjects of the following:</br> <ol class="px-10"><li>1. That the entity responsible for data collection is the Company.</li><li>2. That the purpose of data collection and processing is to enable the provision of an information society service, the security of users of the Internet Service, as well as enabling the creation and posting of content in accordance with the law.</li><li>3. That the collected data is used in a way that allows the identification of individuals who advertise goods and services, in accordance with the preservation of business secrets and the law.</li><li>4. That the entities using the data are those employed by the Company and all directly related legal entities authorized to use the data, as well as all State authorities that, based on the law and/or court decision, have the right to use the data.</li><li>5. That providing personal data is voluntary, and that anyone who does not wish to be a registered user of the digital platform is not obliged to provide any data.</li><li>6. That the data subject who has given consent to the collection and processing of data can withdraw their consent at any time and without explanation, which has the legal consequence of ceasing the possibility of using the digital platform, the maturity of all outstanding obligations incurred during the use of the digital platform, and that further data collection from the data subject who withdrew consent ceases.</li><li>7. That in case of unauthorized processing, individuals have rights to personal data protection, as well as other rights granted to them by law.</li></ol>The data collected for the above-mentioned purposes include: name, surname, email, address, country, city, phone, credit card number. All general acts of the Company must comply with this Personal Data Protection Policy. If any general act of the Company is not in line with this Policy regarding personal data protection, the provisions of this Policy apply.',
    notices: 'NOTICES',
    termsAndConditionSection5:
      'The user agrees that the Company may periodically send notices related to the content of the digital platform, notices regarding the functioning of the digital platform, news and promotions of the Company, as well as promotional notices.',
    complaints: 'COMPLAINTS',
    termsAndConditionSection6:
      'As the Company provides an information society service, it is not possible to file a complaint about the performed service, nor is it possible to exchange it for another service, nor transfer the compensation to another service. The information society service provided by the Company is fully executed because the provision of the service began after the explicit prior consent of the user to use the service.',
    copyright: 'COPYRIGHT',
    termsAndConditionSection7:
      "The Company holds exclusive copyright and intellectual property rights to the digital platform, as well as all individual elements that constitute it, such as text, visual and audio elements, visual identity, data and databases, source code, and other service elements, of which the Company is the author. Unauthorized use of any part of the digital platform without the explicit prior written permission from the Company, as the exclusive copyright holder, will be considered a violation of the Company's copyright and is subject to legal action to the fullest extent. The digital platform may contain elements on which other parties hold exclusive copyright, trademark, and other intellectual property rights, such as user content, content from business partners, advertisers, and similar entities. Other parties have exclusive responsibility for the content on which they hold those rights, regardless of the presence of such content on the Company's digital platform. By posting content on the digital platform, the user agrees that it becomes visible to every visitor of the digital platform, including visitors of other information society service providers or publications with which the Company has such cooperation. Further transmission of content from other parties or parts of content from any part of the digital platform is allowed only with the mandatory explicit prior consent of the Company, with a note indicating that the content is taken from the digital platform, along with a link to the corresponding location of the content. The Company is exclusively responsible only for content for which it holds copyright. Each individual is solely responsible for the content that is their copyright work or content that they have independently posted and made publicly available through the digital platform.",
    directions: 'DIRECTIONS',
    termsAndConditionSection8:
      "Registered users undertake to respect the guidelines listed here when creating content. The Company has the right, but not the obligation, to remove or not publish content that any registered user places on the digital platform without explanation. The user is responsible for the posted content, especially if, according to the Company's discretionary judgment, the content includes (but is not limited to): </br><li>Entering content into the wrong categories (e.g., providing a phone number in a field not intended for that)</li></br><li>Incorrect categorization of content (e.g., posting ads that are not relevant to the category in which they are advertised)</li></br><li>If it is a duplicate ad (identical ad posted multiple times) when the subject of the ad is renting or leasing (renting an apartment, renting a bike, etc.)</li></br><li>Entering incorrect images in the ad (e.g., poor quality; with subsequently added contact phone, logo of another website or company, text like for rent, etc.)</li></br><li>Openly offensive content or content that promotes racism, intolerance, hatred, or physical harm of any kind directed at any group or individual</li></br><li>Harasses or promotes the harassment of another person</li></br><li>Exploits people in a sexual or violent manner</li></br><li>Contains nudity, excessive violence, or offensive content or contains links to adult websites</li></br><li>Requests personal information from persons under 18 years of age</li></br><li>Publicly discloses information that poses a risk to the privacy or security of any person</li></br><li>Contains or promotes information that you know to be untrue or that leads to a wrong conclusion or promotes unauthorized activities or whose content is offensive, threatening, full of threats, indecent, or defamatory</li></br><li>Contains or promotes unauthorized or unauthorized copying of another person's copyrighted work</li></br><li>Includes the transmission of unwanted mail, circular letters, or mass mailings, instant messages, or spam</li></br><li>Contains pages with restricted access or pages that can only be accessed with a password or hidden pages or images (those not linked to other pages)</li></br><li>Encourages or promotes criminal activities or businesses or provides instructions for performing unauthorized activities, including but not limited to the creation or purchase of illegal weapons, violation of someone's privacy, or the creation or creation of computer viruses</li></br><li>Asks for passwords or information that personally identifies you for commercial or unauthorized purposes from other users</li></br> <li>Includes other commercial activities and/or issuance outside the scope of the digital platform, without the prior written consent of the Company, such as competitions, lotteries with prizes in goods and services, or pyramid schemes<li>Includes a photo or video of another person that you have posted without that persons consent</li></br><li>Violates the right to privacy, the right to public disclosure, the right to protection from defamation, copyright, trademark rights, contractual rights, or any other personal rights. Violates the right to privacy, the right to public disclosure, the right to protection from defamation, copyright, trademark rights, contractual rights, or any other personal rights. Below are examples, without limitation of any kind, of activities that are prohibited or prohibited on the digital platform:</li></br><li>Criminal or tortious activities, including child pornography or erotica, fraud, distribution of pornographic content, distribution, or enjoyment of drugs, gambling, harassment, stalking, spam, pyramid schemes, Ponzi schemes, sending viruses or other harmful files, copyright infringement, patent infringement, or theft of trade secrets</li></br><li>Advertising to users or offering to buy or sell any products or services through unauthorized or unauthorized use of the Service</li></br><li>Attempting to bypass or modify, encouraging, or assisting others to bypass or modify any of the security technologies or software that are part of the digital platform</li></br><li>Falsifying TCP/IP packet headers or any part of information in the header in any post or otherwise using the digital platform to send altered, deceptive, or incorrect information that identifies the source</li></br> <li>Activities involving the use of viruses, bots, worms, or any other computer code, files, or programs that disrupt, destroy, or limit the functionality of computer software or hardware, or otherwise allow unauthorized use or access to a computer or computer network<li>Interference with the access of any user, host, or network to the digital platform</li></br><li>Covering or obscuring advertising via banners on the user profile page or any page of the digital platform through HTML/CSS or in any other way</li></br><li>Including HTML, CSS, or any other coding on the user profile page, including but not limited to any hidden or otherwise surreptitious codes in submitted content not related to the nature of the submitted content</li></br><li>Any automatic use of systems, including but not limited to the use of scripts to send images or videos</li></br><li>Interfering, disrupting, or creating unnecessary burden on the digital platform, online, or services related to it.</li></br><li>Imitating or attempting to imitate a legal or physical entity</li></br><li>Using another user's access data or username at any time or disclosing the password to third parties or allowing third parties to access a user account that is not theirs</li></br><li>Selling or transferring a user profile in any other way</li></br><li>Using information obtained from the digital platform to harass, abuse, or harm any person and attempting to do so</li></br><li>Unauthorized commercial advertising on the user profile, accepting payment, or anything of value from third parties in exchange for conducting commercial activities through unauthorized or prohibited use of the digital platform on behalf of that person</li></br><li>Deleting or otherwise modifying copyright notices, trademarks, or other ownership rights notices appearing on user content, unless it is content that the user posts</li></br> <li>Using meta tags or other hidden text or metadata using the Company's name, trademark, URL, or product name without the prior express permission of the Company,</li></br><li>Attempting to probe, scan, or test the vulnerability of any part of the digital platform or violate any security measures or identity verification measures</li></br> <li>Collecting or storing personal data about other users without their explicit permission</li></br> <li>Imitating or falsely representing affiliation with any person, through pre-sent text or other forms of social engineering or other forms of deception</li></br> <li>Using the Services in a manner that is not in accordance with any applicable laws and regulations, a violation of the Service or network security.</li></br> The Company has the right, but not the obligation, to monitor all user activities and user content associated with the digital platform. The Company may investigate any reported violations of its guidelines and other reports and may take any legal or technical actions it deems appropriate. The Company will investigate circumstances that may involve such violations and may call for cooperation and cooperate with relevant state authorities during the identification, investigation, or criminal prosecution of persons involved in such violations of guidelines or laws. The Company reserves the discretionary right to use all legal means, including but not limited to removing user accounts and user content, as well as immediately suspending all Company services that the user uses, in case of any violation of these Terms or if the Company cannot verify or verify any information that the user sends to the Company.",
    postingAd: 'ADVERTISING AND AD MESSAGE',
    termsAndConditionSection9:
      'The advertiser of the ad message is the Company, which is a provider of information society services and exclusively provides advertising services over the Internet. For the content, accuracy, and correctness, as well as the validity and legality of the ad message, the responsibility lies solely with the person who entered the ad message. For all legal consequences arising from entering the ad message, the responsibility rests solely with the person who entered the ad message on the digital platform. The Company reserves the right not to publish content that violates the provisions of the laws of the Republic of Serbia, especially the Advertising Law. In the event of receiving such an ad, the Company will contact the advertiser to modify the ad message. The Company may, at any time, at its own discretion, refuse to post any ad message that violates the provisions of the Law or these Terms of Use, but is not responsible for the content of such a message; the responsibility lies solely with the advertising person or the person who provided such content.',
    registeredUsers: 'REGISTERED INDIVIDUAL USERS',
    termsAndConditionSection10:
      'Registration on the digital platform for individuals is free and available to all visitors. During registration, individuals are required to fill out a form with personal information. This data is used as prescribed by the Personal Data Protection Regulation. By registering on the Service, individuals get the following options:</br><ol class="px-10"><li>1. The ability to save ads</li><li>2. By posting an ad in the Companys database, the user gains the possibility for that ad to be included in the ads on the digital platform, as well as the ability for users with search rights (the right to search the collection is unlimited for individuals accessing the digital platform) to contact them directly.</li><li>3. The ability to deactivate the profile</li><li>4. The user can request the deactivation of their profile at any time by sending an email to the address info@rentasvet.rs. A deactivated profile cannot be reactivated by the user. In case of deactivation of the users profile, the Company does not guarantee that third parties have not stored the data contained in the users ad from the period when the ad was active, nor that this data will not be later used for the purpose of contacting by persons who have stored the data.</li></ol>The digital platform allows registered individual users to inform the Company, via the address: info@rentasvet.rs, if they believe that someone is abusing user data and contacting the user for reasons other than the ad, i.e., reasons that are not the subject of the ad.',
    registredUsers2: 'REGISTERED USERS LEGAL ENTITIES',
    termsAndConditionSection11:
      "Registration on the digital platform for legal entities engaged in the rental of goods and services in accordance with their business activities is free and available to all duly registered business entities. When registering, the business entity is required to fill out a form with information about the legal entity. This information is kept in the records of the Company and legal entities in which the Company has majority ownership and will not be used for other purposes, except for the purpose of exercising rights and obligations under these Terms of Use. Registration on the digital platform does not constitute registration of activities or acquisition of status within the meaning of the Companies Act and the Trade Act. The Company does not guarantee that individuals who have registered through the digital platform are properly registered for trade or that they have the status of a business entity. By registering on the digital platform, legal entity users have the opportunity to post ads for all listed categories and subcategories, search the ad collection, and view ads. A registered legal entity user has the right to indicate that the ad has been placed in the Company's digital platform ad database, as well as to display its own trademark, but this does not grant the right to use the Company's logo or trademark or the name of the digital platform in any context. A registered legal entity user undertakes to use information, including contact information, obtained through the Service exclusively for the intended purpose and not to use it for other purposes. Any use of information contrary to these Terms of Use entails liability in accordance with the law.</br><ol class=\"px-10\"><li>1. The ability to save ads</li><li>2. By placing an ad in the Company's database, the agency user acquires the ability for that ad to be included in ads on the digital platform, as well as the ability for users with search rights (the right to search the database is unlimited users accessing the digital platform) to contact them directly.</li><li>3. The ability to deactivate the profile</li><li>4. The legal entity user can request deactivation of their profile at any time by sending an email to info@rentasvet.rs. A deactivated profile cannot be reactivated by the legal entity user. In case of deactivation of the user's profile, the Company does not guarantee that third parties have not stored data contained in the user's ad from the period when the ad was active, nor that this data will not be later used for the purpose of contact by individuals who have stored the data.\"</li></ol>",
    postingAdMessage: 'POSTING AD MESSAGES - ADS',
    termsAndConditionSection12:
      "Registered users advertising items, spaces, or services submit their ads through the ad ordering form on the digital platform. According to the Advertising Law, there is no obligation to submit an Advertising Declaration for online advertising. If all mandatory fields in the ad ordering form are correctly filled, and the ad is complete, it is then published on the digital platform. Ads from users advertising for the first time are visible immediately after the ad is activated. Advertising is charged according to the current Price List. Individuals with outstanding financial obligations to the Company gain the right to publish ads after settling these obligations are recorded. If a user purchases an ad package or other services of the Service (intending to use them over an extended period), that user is protected from any changes in ad prices during the service's advertising period.",
    pricelist: 'PRICE LIST',
    pricelistNormal: 'Price list',
    termsAndConditionSection13:
      "The Company provides information society services for a fee according to the Price List. Fees become due for payment immediately after placing the ad. After the electronic payment of the ad, a fiscal invoice is sent to the registered user's email address as proof of payment. In the case of payment by bank or post office payment slip, the fiscal invoice is sent to the user's email address after the payment is recorded. The Company's Price List is an integral part of these Terms of Use. The Company reserves the right to change the Price List at any time. Changes to the Price List take effect eight days from the date of publication. The current Price List is available at the internet address: {{pricelistLink}}",
    limitation: 'LIMITATION OF LIABILITY',
    termsAndConditionSection14:
      "Users use the digital platform solely at their own risk. The user expressly acknowledges that the Company cannot be held responsible for the conduct of other users or third parties, and the risk of potential damage is entirely borne by those individuals, in accordance with the applicable legislation of the Republic of Serbia. Texts (comments), ratings, and other content that users post in designated sections must be accurate and correct. Users who enter this data are responsible for its accuracy. Accuracy of entry implies that it comes from a competent source or the user's personal experience. For each individual entry, the user who made the entry is solely responsible. The Company does not guarantee the accuracy, reliability, or the content posted by users. The Company does not initiate the transmission of electronic messages submitted by users, does not select the data or documents being transmitted, does not extract or modify data in the content of the message or document, and does not select the recipient of the transmission. This liability statement applies to all damages (material and/or immaterial) or injuries that could arise from hidden defects, errors, interruptions, deletions, malfunctions, delays in operation or transmission, computer viruses, disruptions in communication, theft, destruction, or unauthorized access to data, changes, or misuse of data by third parties, breach of contract, conduct contrary to the Terms of Use, negligence, etc. Except in cases of intent or gross negligence, the Company is not liable for any temporary unavailability of the digital platform, or for partial or complete malfunction or incorrect functioning thereof. The Company is not responsible for technical problems that may lead to delays and/or incorrect processing of electronic data, including the system clock. Service providers for Internet services are responsible for the above. As a provider of information society services, the Company is not responsible for any content posted by another party, a user, including but not limited to the advertising message it transmits, as it neither initiates the transmission nor selects the transmitted content, nor has it excluded or modified the data in the transmitted content, nor has it selected the recipient of the transmission or the recipient of the content. The Company does not guarantee the behavior of third parties or its users. Among other things, the Company does not provide any guarantees that the user who advertised a good or service will be contacted regarding that ad by third parties (i.e., that they will conclude a deal related to the ad), nor that the available information will contain accurate and true data. The digital platform may be temporarily unavailable or available to a limited extent as a result of regular or extraordinary system maintenance or in the case of system upgrades.",
    dispute: 'DISPUTE RESOLUTION',
    termsAndConditionSection15:
      'Any matters not governed by these Terms of Use shall be subject to the applicable laws of the Republic of Serbia. For any disputes that may arise between the Company and users regarding the use of the digital platform, the relevant laws of the Republic of Serbia shall apply. The Company and the user commit to attempting to resolve disputes amicably, and if unsuccessful, the competent authority for dispute resolution is the Commercial Court in Belgrade for legal entities, and the Basic Court in Belgrade for individuals. For any disputes that may arise between two users in connection with the use of the digital platform, the applicable laws of the Republic of Serbia shall apply. Users agree to attempt to resolve disputes amicably, and if unsuccessful, the competent authority for dispute resolution is the Commercial Court in Belgrade for disputes between legal entities, or the First Basic Court in Belgrade for disputes between individuals or between individuals and legal entities. The Company, in no way, mediates or participates in any dispute that may arise between users of the digital platform, unless required by law as a necessary party.',
    amendmentsAndAdditions: 'AMENDMENTS AND ADDITIONS',
    termsAndConditionSection16:
      "The Company reserves the right to amend or supplement these Terms of Use at any time by publishing the amendments and additions in a clear text on the website and sending an email to all registered users at least eight days before the amendments take effect. If an already registered user does not explicitly respond within the specified period (by clicking on the link to accept the Terms of Use), it will be considered that they agree to the new Terms of Use. If an already registered user expressly rejects these Terms of Use (by clicking on the link to reject the Terms of Use), it will be considered that their user status has ceased, all previous rights and obligations are terminated, and the contractual relationship is terminated according to the previous Terms of Use. With the entry into force of the new user conditions, acquired user rights remain unaffected. These Terms of Use come into effect eight days after their publication on the Service's website. Each printed copy of these User Terms has full legal effect under the provisions of the Law on Electronic Document, and its validity or probative force cannot be contested.",
    beograd2023: 'In Belgrade, 2026',
    endDateStatusChange: 'End date need to be grater then current date',
    generalData: 'General data',
    all: 'All',
    exportCsv: 'Export users',
    phoneClicked: 'Phone number view',
    privacyNotice: 'PRIVACY NOTICE',
    termsAndConditionSection17:
      'Collection, processing, and storage of your personal data (personal information) are carried out in accordance with the applicable regulations of the Republic of Serbia and the new European regulation on the protection of personal data. It is of great importance that you safeguard your personal data. The data collected by the rentasvet digital platform include: <ul> <li>- Full name </li> <li>- Email address </li> <li>- Phone number and address </li> <li>- Description and photos of items, spaces, and services you are renting, exchanging, or giving away. </li> By providing this information, you consent to its use for communication purposes related to the rentasvet platform. During the use of the rentasvet platform, we may collect and process data about the devices from which you access the platform (brand, device type, operating system, network data). During the use of the rentasvet platform, we may collect and process data about your location through the IP address or GPS of your mobile phone. When using the payment feature for your ads, we may retain data about your payments to rentasvet, such as transaction references, bank name, account number, and similar. Posting ads with inappropriate content, offensive content, or content that may disturb other users is not allowed. Advertising prohibited activities by law is also not allowed on the rentasvet digital platform. In case of discovering such content, we reserve the right to automatically remove or block such user accounts. If government authorities approach the rentasvet digital platform for assistance in identifying perpetrators of criminal offenses or other types of disputes, we will certainly assist with a proper written request. We will keep your personal data for a period necessary for the smooth provision of the service. If you wish to permanently delete your data, you need to contact us in writing with that request at {{infoMail}}, and your data will be deleted very promptly. You have the right to access all your personal data that we have collected. You have the right to modify your data if it is incorrect, replace photos, and change your phone number at any time. At any time, you have the right to submit a written request for the deletion of your personal data, except in cases where they may prevent the investigation and detection or prosecution of criminal offenses. In case of a data breach that may pose a risk to you, you have the right to be informed about it without delay. This notice is subject to change. In case of significant changes, the rentasvet platform will inform all users of the changes via email or other types of messages. In that case, the earlier available version would be archived.',
    titleEnglish: 'Title (English only)',
    enterYourAdTitleEn: 'Enter your ad title in english',
    descriptionEnglish: 'Description (English only)',
    titleDescriptionEn: 'Ad Title and Description In English',
    pleaseCompleteEn:
      'Please complete the fields by providing the title and description of your advertisement. It is essential that all content is written exclusively in English to ensure clarity and better understanding. Your adherence to this language requirement is appreciated.',
    fillingOut: '( *Filling out these fields is not required. )',
    exportAds: 'Export ads',
    dataInEnglish: 'Data in English',
    corporateCelebrations: 'Corporate celebrations',
    quadsMotorsBicycles: 'Quads, Motors, Bicycles',
    busesCampersVans: 'Buses, Campers, Vans',
    classesTrainingsAndWorkshops: 'Classes, Trainings and Workshops',
    smallHomeRepairs: 'Small home repairs',
    photographyAndRecording: 'Photography and recording',
    otherServices: 'Other services',
    workingMachines: 'Working machines',
    otherMachinesVehiclesAndTools: 'Other machines, vehicles and tools',
    adsHistory: 'Recently Viewed Ads',
    userNotFoundDescription: 'The requested user does not exist or has been removed',
    userStatistics: 'User statistics',
    totalAds: 'Total ads',
    memberSince: 'Member since',
    adsFrom: "User's ads",
    noAdsFound: 'No ads found',
    userHasNoActiveAds: 'This user currently has no active ads',
    companyInfo: 'Company information',
    priceNotSpecified: 'Price not specified',
    views: 'Views',
    paused: 'Paused',
    loading: 'Loading...',
  },
};
